import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './map-of-local-listings.css'

const MapOfLocalListings = (props) => {
  return (
    <div className="map-of-local-listings-container1">
      <Helmet>
        <title>Map-of-Local-Listings - Dogeet</title>
        <meta
          property="og:title"
          content="Map-of-Local-Listings - Dogeet"
        />
        <link
          rel="canonical"
          href="https://dogeet.com/map-of-local-listings"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-panel">
        <div className="hero-panel-media">
          <img
            src="https://images.pexels.com/photos/4881165/pexels-photo-4881165.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            alt="Map Exploration Background"
            className="hero-panel-img"
          />
          <div className="hero-panel-scrim"></div>
        </div>
        <div className="hero-panel-container">
          <div className="hero-panel-content">
            <h1 className="map-of-local-listings-hero-title hero-title">
              Find Local Treasures for DOGE
            </h1>
            <p className="hero-subtitle">
              Explore your neighborhood&apos;s community bazaar where every
              price tag is a &quot;Wow&quot;.
            </p>
            <div className="hero-panel-controls">
              <div className="hero-panel-search-box">
                <div className="hero-panel-input-wrapper">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="hero-panel-icon"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="m21 21l-4.34-4.34"></path>
                      <circle cx="11" cy="11" r="8"></circle>
                    </g>
                  </svg>
                  <input
                    type="text"
                    placeholder="Search location or items..."
                    className="hero-panel-input"
                  />
                </div>
                <button className="btn btn-primary btn-lg">Search</button>
              </div>
              <div className="hero-panel-filters">
                <div className="hero-panel-toggle-group">
                  <span className="hero-panel-label">DOGE Price Mode</span>
                  <label className="hero-panel-switch">
                    <input type="checkbox" checked="true" id="usd-toggle" />
                    <span className="map-of-local-listings-thq-hero-panel-slider-elm1"></span>
                  </label>
                  <span className="hero-panel-toggle-text">Show USD Ref</span>
                </div>
                <div className="hero-panel-quick-actions">
                  <button className="btn btn-outline btn-sm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 4h16v2.172a2 2 0 0 1-.586 1.414L15 12v7l-6 2v-8.5L4.52 7.572A2 2 0 0 1 4 6.227z"
                      ></path>
                    </svg>
                    <span>
                      {' '}
                      Categories
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </button>
                  <button className="btn btn-outline btn-sm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </g>
                    </svg>
                    <span>
                      {' '}
                      Within 10 miles
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="map-canvas">
        <div className="map-canvas-bg">
          <video
            autoPlay="true"
            muted="true"
            loop="true"
            playsInline="true"
            src="https://videos.pexels.com/video-files/5759121/5759121-hd_1920_1080_30fps.mp4"
            className="map-canvas-video"
          ></video>
          <div className="map-canvas-overlay"></div>
        </div>
        <div className="map-canvas-pins">
          <div className="map-of-local-listings-thq-map-pin-item-elm1 map-pin-item pin-tech">
            <div className="map-pin-pulse"></div>
            <div className="map-pin-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 12h6M9 6v12m-3 0h6a6 6 0 1 0 0-12H6"
                ></path>
              </svg>
            </div>
            <div className="map-pin-tooltip">
              <span className="tooltip-title">Mining Rig</span>
              <span className="tooltip-price">Ð 45,000</span>
            </div>
          </div>
          <div className="map-of-local-listings-thq-map-pin-item-elm2 map-pin-item pin-home">
            <div className="map-pin-pulse"></div>
            <div className="map-pin-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1zm3-12a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2M18 22v-3"></path>
                  <circle cx="10" cy="10" r="3"></circle>
                </g>
              </svg>
            </div>
            <div className="map-pin-tooltip">
              <span className="tooltip-title">Comfy Sofa</span>
              <span className="tooltip-price">Ð 1,200</span>
            </div>
          </div>
          <div className="map-of-local-listings-thq-map-pin-item-elm3 map-pin-item pin-cluster">
            <div className="cluster-count">
              <span>24</span>
            </div>
          </div>
        </div>
        <div className="map-canvas-ui">
          <h2 className="section-title">Live Dogeet Map</h2>
          <p className="section-content">
            Click pins to view details. Zoom in to find local sellers.
          </p>
        </div>
      </section>
      <section className="listing-preview">
        <div className="listing-preview-container">
          <div className="map-of-local-listings-listing-card">
            <div className="listing-card-media">
              <img
                src="https://images.pexels.com/photos/2460457/pexels-photo-2460457.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Vintage Camera"
                className="listing-card-img"
              />
              <span className="listing-card-tag">Collectibles</span>
            </div>
            <div className="listing-card-body">
              <div className="listing-card-header">
                <h3 className="listing-card-title">Vintage Film Camera</h3>
                <button className="btn-icon-favorite">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"
                    ></path>
                  </svg>
                </button>
              </div>
              <div className="listing-card-price-row">
                <span className="listing-price-doge">Ð 850</span>
                <span className="listing-price-usd">($12.45)</span>
              </div>
              <div className="listing-card-meta">
                <span className="meta-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </g>
                  </svg>
                  <span>
                    {' '}
                    2.4 miles away
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
              <div className="listing-card-actions">
                <button className="btn btn-primary btn-sm">
                  Message Seller
                </button>
                <button className="btn btn-outline btn-sm">
                  View Full Listing
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="control-strip">
        <div className="control-strip-wrapper">
          <div className="control-strip-group">
            <div className="control-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M2 5h20M6 12h12m-9 7h6"
                ></path>
              </svg>
              <span className="control-label">Categories:</span>
              <div className="category-chips">
                <label className="chip">
                  <input type="checkbox" checked="true" />
                  <span>All</span>
                </label>
                <label className="chip">
                  <input type="checkbox" />
                  <span>Tech</span>
                </label>
                <label className="chip">
                  <input type="checkbox" />
                  <span>Home</span>
                </label>
                <label className="chip">
                  <input type="checkbox" />
                  <span>Auto</span>
                </label>
              </div>
            </div>
          </div>
          <div className="control-strip-divider"></div>
          <div className="control-strip-group">
            <div className="control-item">
              <span className="control-label">Sort by:</span>
              <select className="control-select">
                <option>Nearest First</option>
                <option>Price: Low to High</option>
                <option>Newest Added</option>
              </select>
            </div>
            <div className="control-item power-seller">
              <span className="control-label">Power Sellers Only</span>
              <label className="hero-panel-switch sm">
                <input type="checkbox" />
                <span className="map-of-local-listings-thq-hero-panel-slider-elm2"></span>
              </label>
            </div>
          </div>
        </div>
      </section>
      <section className="results-drawer">
        <div className="results-drawer-container">
          <div className="results-drawer-header">
            <h2 className="section-subtitle">Nearby Results (42)</h2>
            <button className="btn-sm btn-link">Expand All</button>
          </div>
          <div className="card-rail-wrapper">
            <div className="card-rail-item">
              <div className="rail-card">
                <img
                  src="https://images.pexels.com/photos/3069036/pexels-photo-3069036.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Result 1"
                  className="rail-card-img"
                />
                <div className="rail-card-info">
                  <span className="rail-card-title">Custom PC Case</span>
                  <span className="rail-card-price">Ð 2,500</span>
                  <button className="btn btn-sm btn-accent">Contact</button>
                </div>
              </div>
            </div>
            <div className="card-rail-item">
              <div className="rail-card">
                <img
                  src="https://images.pexels.com/photos/19331551/pexels-photo-19331551.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Result 2"
                  className="rail-card-img"
                />
                <div className="rail-card-info">
                  <span className="rail-card-title">Handmade Rug</span>
                  <span className="rail-card-price">Ð 4,000</span>
                  <button className="btn btn-sm btn-accent">Contact</button>
                </div>
              </div>
            </div>
            <div className="card-rail-item">
              <div className="rail-card">
                <img
                  src="https://images.pexels.com/photos/2239422/pexels-photo-2239422.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Result 3"
                  className="rail-card-img"
                />
                <div className="rail-card-info">
                  <span className="rail-card-title">Qatari Textile</span>
                  <span className="rail-card-price">Ð 1,800</span>
                  <button className="btn btn-sm btn-accent">Contact</button>
                </div>
              </div>
            </div>
            <div className="card-rail-item">
              <div className="rail-card">
                <img
                  src="https://images.pexels.com/photos/19528079/pexels-photo-19528079.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Result 4"
                  className="rail-card-img"
                />
                <div className="rail-card-info">
                  <span className="rail-card-title">Street Art Print</span>
                  <span className="rail-card-price">Ð 350</span>
                  <button className="btn btn-sm btn-accent">Contact</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="safety-banner">
        <div className="safety-banner-wrapper">
          <div className="safety-alert">
            <div className="safety-alert-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <div className="safety-alert-content">
              <h2 className="section-subtitle">Stay Safe in the Bazaar</h2>
              <p className="section-content">
                <span>
                  Always meet in public places for local trades. Dogeet is
                  non-custodial; verify transactions on-chain before handing
                  over items.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <a href="#">
                  <div className="btn-link">
                    <span>Read Full Safety Guide</span>
                  </div>
                </a>
              </p>
            </div>
            <div className="safety-alert-action">
              <button className="btn btn-outline btn-sm">
                Report a Listing
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="fast-post">
        <div className="fast-post-container">
          <div className="fast-post-card">
            <div className="fast-post-grid">
              <div className="fast-post-text">
                <h2 className="section-title">Got Wares?</h2>
                <p className="section-content">
                  Join the local community. Post your first listing in under 60
                  seconds and start earning DOGE today.
                </p>
              </div>
              <div className="fast-post-actions">
                <div className="fast-post-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 12h6M9 6v12m-3 0h6a6 6 0 1 0 0-12H6"
                    ></path>
                  </svg>
                  <span>Only Ð 10 to Post</span>
                </div>
                <button className="btn btn-secondary btn-xl">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25z"
                    ></path>
                  </svg>
                  <span>
                    {' '}
                    Create Fast Listing
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="map-of-local-listings-container2">
        <div className="map-of-local-listings-container3">
          <Script
            html={`<style>
        @keyframes pulsePin {0% {transform: scale(1);
opacity: 0.5;}
100% {transform: scale(3);
opacity: 0;}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="map-of-local-listings-container4">
        <div className="map-of-local-listings-container5">
          <Script
            html={`<script defer data-name="dogeet-map-logic">
(function(){
  // Toggle USD Reference Visibility
  const usdToggle = document.getElementById('usd-toggle');
  const usdPrices = document.querySelectorAll('.listing-price-usd');

  if (usdToggle) {
    usdToggle.addEventListener('change', (e) => {
      usdPrices.forEach(price => {
        price.style.display = e.target.checked ? 'inline' : 'none';
      });
    });
  }

  // Simple Pin Hover Simulation
  const pins = document.querySelectorAll('.map-pin-item');
  pins.forEach(pin => {
    pin.addEventListener('mouseenter', () => {
      const tooltip = pin.querySelector('.map-pin-tooltip');
      if (tooltip) {
        tooltip.style.opacity = '1';
        tooltip.style.transform = 'translateY(0)';
      }
    });
    pin.addEventListener('mouseleave', () => {
      const tooltip = pin.querySelector('.map-pin-tooltip');
      if (tooltip) {
        tooltip.style.opacity = '0';
        tooltip.style.transform = 'translateY(10px)';
      }
    });
  });

  // Category Chip Selection
  const chips = document.querySelectorAll('.chip input');
  chips.forEach(chip => {
    chip.addEventListener('change', (e) => {
      if (e.target.checked && e.target.nextElementSibling.textContent === 'All') {
        chips.forEach(c => {
          if (c !== e.target) c.checked = false;
        });
      } else if (e.target.checked) {
        const allChip = Array.from(chips).find(c => c.nextElementSibling.textContent === 'All');
        if (allChip) allChip.checked = false;
      }
    });
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default MapOfLocalListings
